import React, { useState, useEffect, useRef } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useLocation, useNavigate } from "react-router-dom";
import { Add_update_super_admins, currentUserProfileQuery, Role_Account_Query, Upload_Document } from "../services/userAPI";
import "./resuableHeader.css";
import Icon2 from "../Images/QPLogo.png";
import ClanCrewDashboard from "../Images/clan-crew-dashboard-logo.png";
import HeaderCloseIcon from "../Images/header_redcircle_down.png";
import HeaderOpenIcon from "../Images/header-circle-down.png";
import HeaderOpenW from "../Images/expand_circle-down-white-color.png";
import { IoIosLogOut } from "react-icons/io";
import EditIcon from "../Images/editIcon2.png";
import LogoutIcon from "../Images/logotIcon.png";
import { Menu, X } from "lucide-react";
import { Button, Col, message, Modal, Row, Select, Upload } from "antd";
import Home from "../Images/home-image.png";
import TextInputField from "../reusableField/TextInputField2";
import CreateClientImage from "../Images/add-new-profile-photo.png";
import { passwordRegex, validationRegexAmount, validationRegexOnlyAlpha } from "../regex/regex";
import "../components/globalAdmin/globalAdmin.css"
import defaultProfile from "../Images/profile-user.png";
import GlobalIcon from "../Images/Globe-icon.png";
import ReportsIcon from "../Images/reportsIcon.svg";
import TicketingSystemIcon from "../Images/ticketingSystemIconBlackColor.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ReusableHeader = ({ setIsAuthenticated = () => { } }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const navigate = useNavigate();
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [clientImage, setClientImage] = useState(null);
  const [errors, setErrors] = useState({})
  const imageRef = useRef(null);
  const [touched, setTouched] = useState({})
  const [isPickingColor, setIsPickingColor] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [uploadedFilename, setUploadedFilename] = useState(null);
  const [maskedPassword, setMaskedPassword] = useState()
  const [actualPassword, setActualPassword] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setActualPassword(value);
    setMaskedPassword("*".repeat(value.length));
    setFormData({ ...formData, password: value });
  };
  const [passwordVisible, setPasswordVisible] = useState(false);
  const dropdownRef = useRef(null);

  // Use only one toggle function
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };


  // const { data: roleData, loading: roleLoading, error: roleError } = useQuery(Role_Account_Query, {
  //   variables: { accountId: 1 },
  //   skip: false,
  //   onError: (err) => {
  //     console.error("Error fetching roles:", err.message);
  //     message.error("Failed to fetch roles. Please try again.");
  //   },
  // });

  // const roleOptions = React.useMemo(() => {
  //   if (roleLoading || roleError || !roleData?.getAllJobrole) return [];
  //   return roleData?.getAllJobrole?.map((role) => ({
  //     value: role.id,
  //     label: role.name,
  //     disabled: role.name === "Marketing", // Add disabled property here
  //   }));
  // }, [roleData, roleLoading, roleError]);

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    // Add event listener when the menu is open
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);


  const showDeleteModal = (user) => {
    setSelectedUser(user);
    setDeleteModalVisible(true);
  };

  const handleImageClick = (e) => {
    if (!isPickingColor) return;
    e.preventDefault();
    e.stopPropagation();

    if (selectedColor) {
      setFormData(prevData => ({
        ...prevData,
        brandColor: selectedColor.hex
      }));
    }
    setIsPickingColor(false);
    if (imageRef.current) {
      imageRef.current.classList.remove('color-picking-cursor');
      imageRef.current.classList.remove('active-picker-border');
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    emailId: "",
    password: "",
    phoneNumber: "",
    imageUrl: "",
  });

  useEffect(() => {
    setIsFormValid(validateForm());
  }, [formData]);

  const [uploadDocument] = useMutation(Upload_Document, {
    onCompleted: (data) => {
      if (data.uploadDocument.success) {
        const filename = data.uploadDocument?.data?.data?.filename;
        const imageUrl = data.uploadDocument?.data?.data?.url;
        setUploadedFilename(filename);

        setFormData((prevData) => ({
          ...prevData,
          imageUrl: imageUrl,
          // filename: filename,
        }));
        message.success("Image uploaded successfully!");
      } else {
        message.error("Failed to upload image: " + data.uploadDocument.message);
      }
    },
    onError: (error) => {
      message.error("Upload failed: " + error.message);
    },
  });

  const { loading, error, data, refetch } = useQuery(currentUserProfileQuery, {
    skip: !!userData,
    fetchPolicy: "network-only",
  });

  const [addUpdateSuperAdmin] = useMutation(Add_update_super_admins);

  useEffect(() => {
    if (data?.currentUserProfile) {
      setUserData(data.currentUserProfile);
    }
  }, [data]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const logout = () => {
    localStorage.removeItem("flutter.accessToken");
    setIsAuthenticated(false);
    setUserData(null);
    window.location.href = "/login-page";
  };

  const truncateDesignation = (designation) => {
    const words = designation.split(" ");
    if (words.length > 2) {
      return `${words.slice(0, 2).join(" ")}...`;
    }
    return designation;
  };

  const truncateUserName = (designation) => {
    const firstName = designation.split(" ")[0];
    return firstName.length > 13 ? firstName.substring(0, 13) + "..." : firstName;
  };

  <div className="loading-container">
    <div className="spinner"></div>
  </div>

  if (error) return <p>Error: {error.message}</p>;

  const getIcon = () => {
    if (isDropdownOpen) {
      return HeaderOpenIcon;
    }
    if (isHovered) {
      return HeaderOpenW;
    }
    return HeaderCloseIcon;
  };

  // Add these functions
  const handleEditClick = () => {

    setFormData({
      userId: userData?.id,
      name: userData?.name || "",
      emailId: userData?.email || "",
      password: userData?.password || "",
      phoneNumber: userData?.phoneNumber || "",
      imageUrl: userData?.profilePicture || "",
      roleId: userData?.roleId || userData?.role?.id || "",
    });

    setIsEditModalVisible(true);
  };

  const handleCancel = () => {
    setIsEditModalVisible(false);
    setFormData({
      name: "",
      emailId: "",
      password: "",
      phoneNumber: "",
      imageUrl: "",
    });
    setClientImage(null);
    setTouched({});
    setErrors({});
    setIsEditModalVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };



  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = "Enter users name.";
    }

    if (!formData.emailId) {
      newErrors.emailId = "Enter email-id.";
    } else if (!emailRegex.test(formData.emailId)) {  // Check email format
      newErrors.emailId = "Please enter a valid email address.";
    }

    if (!formData.imageUrl && !clientImage && !formData.mainLogoUrl) {
      newErrors.clientImage = "Upload image.";
    }

    if (!formData.password) {
      newErrors.password = "Enter password.";
    }

    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Enter contact number.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      name: true,
      emailId: true,
      password: true,
      phoneNumber: true,
      clientImage: true,
    });

    if (!validateForm()) {
      message.error("Please fix the errors before submitting.");
      return;
    }

    try {
      const { data: updateData } = await addUpdateSuperAdmin({
        variables: {
          updatedUser: {
            userId: userData.id,
            firstName: formData.name,
            surname: "",
            email: formData.emailId,
            password: formData.password,
            contactNumber: formData.phoneNumber,
            profilePicture: uploadedFilename,
            userStatus: null,
            userType: null,
            roleId: formData.roleId || userData?.roleId || userData?.role?.id || ""
          }
        }
      });

      if (updateData?.addUpdateSuperAdmins?.success) {
        handleCancel();
        // Refresh the user data
        setUserData(prev => ({
          ...prev,
          name: formData.name,
          email: formData.emailId,
          phoneNumber: formData.phoneNumber,
          password: formData.password,
          profilePicture: updateData?.addUpdateSuperAdmins?.data?.profilePicture
        }));

        // Refetch the query to get fresh data
        await refetch();
        message.success("Profile updated successfully!");
      } else {
        message.error(error.message);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleImageChange = ({ file }) => {
    if (!file) {
      message.error("Invalid file object.");
      return;
    }

    const actualFile = file.originFileObj || file;

    if (!actualFile) {
      message.error("No valid file detected.");
      return;
    }

    const allowedFormats = ["image/jpeg", "image/png"];
    if (!allowedFormats.includes(actualFile.type)) {
      message.error("Invalid file format. Only JPEG and PNG are allowed.");
      return;
    }

    try {
      // Create a preview of the image
      const reader = new FileReader();
      reader.onload = (e) => {
        setClientImage(e.target.result);
      };
      reader.readAsDataURL(actualFile);

      setErrors((prevErrors) => ({
        ...prevErrors,
        clientImage: "", // Clear error for clientImage
      }));

      // Upload the actual file
      uploadDocument({
        variables: {
          s3folder: "COMPANY_LOGO",
          document: actualFile, // Pass the raw file object here
        },
        context: {
          useMultipart: true, // Ensure the Apollo Client supports multipart file uploads
        },
      });
    } catch (error) {
      console.error("Error handling the file:", error);
      message.error("File upload failed.");
    }
  };

  return (
    <header className="header-container">

      <div className="reusable-logo-container">
        {!(isMobile && window.innerWidth < 640 && location.pathname === "/create") && (<img
          src={
            userData?.role?.toLowerCase().includes("clan crew") ||
              userData?.role?.toLowerCase() === "clancrew"
              ? ClanCrewDashboard
              : Icon2
          }
          alt="Logo"
          className="cursor-pointer"
          onClick={() => {
            if (!userData) return;

            const role = userData.role?.toLowerCase();

            if (role === "admin") {
              navigate("/admin-dashboard");
            } else if (role?.includes("clan crew") || role === "clancrew") {
              navigate("/clan-crew-dashboard");
            } else {
              navigate("/dashboard");
            }
          }}
        />
        )}
      </div>

      {isMobile && !(location.pathname === "/create") && (
        <div className="mobile-menu-button">
          {isMobileMenuOpen ? (
            <X className="menu-icon" onClick={toggleMobileMenu} />
          ) : (
            <Menu className="menu-icon" onClick={toggleMobileMenu} />
          )}
        </div>
      )}

      {!isMobile && location.pathname === "/create" || location.pathname === "/create-client-form" ? (
        <></>
      ) : (
        userData && (
          <div className={`profile-dropdown ${isDropdownOpen ? "open" : ""}`} ref={dropdownRef} >
            <div
              className="profile-button"
              onClick={toggleDropdown}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div className="profile-content">
                <img src={getIcon()} alt="Toggle" className="header-icon" onClick={(e) => {
                  // Prevent the click from bubbling to parent elements 
                  e.stopPropagation();
                  toggleDropdown();
                }} />
                <div className="text-container">
                  <span className="profile-name">{truncateUserName(userData.name)}

                  </span>
                  <span
                    className="profile-designation"
                    title={userData.role}
                  >
                    {truncateDesignation(userData.role)}
                  </span>
                </div>
                <img
                  // src={userData.profilePicture || "default-profile-image.png"}
                  src={userData.profilePicture ? userData.profilePicture : defaultProfile}
                  alt="User"
                  className="profile-image"
                />
              </div>
            </div>

            {isDropdownOpen && (
              <div className="actions-container">

                <div className="edit-container">
                  <button
                    className="profile-edit-button"
                    onClick={handleEditClick}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <img
                      src={EditIcon}
                      alt="Edit"
                      style={{
                        width: "16px",
                        height: "16px",
                        objectFit: "contain",
                      }}
                    />
                    <span>Edit</span>
                  </button>
                </div>
                <div className="logout-container">
                  <button
                    className="logout-button"
                    onClick={logout}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <img
                      src={LogoutIcon}
                      alt="Logout"
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                      }}
                    />
                    <span>Logout</span>
                  </button>
                </div>

              </div>
            )}
          </div>
        )
      )}

      <Modal
        title="Edit Profile"
        open={isEditModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        width={1000}
        closable={false}
        style={{ marginLeft: "4%" }}
      // size="lg"
      >
        <div className="add-user-container">
          <Row className="user-form" style={{ display: "flex", alignItems: "center", marginLeft: "3%", }}>
            <Col span={24}>
              <Row gutter={[16, 16]} align="middle">
                <Col sm={4} xs={8} md={4} lg={4} style={{ flexShrink: 0 }}>
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <Upload
                      style={{ marginLeft: "-22%" }}
                      name="clientImage"
                      showUploadList={false}
                      customRequest={handleImageChange}
                      accept="image/*"
                    >
                      <div className="global-admin-image-upload-circle">
                        {clientImage ? (
                          <img
                            ref={imageRef}
                            src={clientImage}
                            alt="Uploaded"
                            className="uploaded-image"
                            onClick={handleImageClick}
                          />
                        ) : formData.imageUrl ? (
                          <img
                            ref={imageRef}
                            src={formData.imageUrl}
                            alt="Existing Client"
                            className="uploaded-image"
                            onClick={handleImageClick}
                          />
                        ) : formData.mainLogoUrl ? (
                          <img
                            ref={imageRef}
                            src={formData.mainLogoUrl}
                            alt="Existing Logo"
                            className="uploaded-image"
                            onClick={handleImageClick}
                          />
                        ) : (
                          <img
                            src={CreateClientImage}
                            alt="Upload Icon"
                            className="upload-icon"
                          />
                        )}
                      </div>
                      {touched.clientImage && errors.clientImage && (
                        <div className="createClientErrors">{errors.clientImage}</div>
                      )}
                    </Upload>
                  </div>
                </Col>

                <Col sm={20} xs={16} md={20} lg={20}>
                  <Row gutter={[16, 16]}>
                    <Col sm={12} xs={24} md={12} lg={12}>
                      <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                        User's Name<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                      </label>

                      <input
                        name="name"
                        className="EditUserTextInput"
                        value={formData.name}
                        placeholder="Enter User's Name"
                        feedbackMessage="Please input the user name."
                        validationRegex={validationRegexOnlyAlpha}
                        onChange={(e) => {
                          const value = e.target.value.trimStart();

                          handleInputChange({
                            ...e,
                            target: {
                              ...e.target,
                              name: "name",
                              value: value,
                            },
                          });
                        }}
                      />

                      {touched.name && errors.name && (
                        <div className="createClientErrors">{errors.name}</div>
                      )}
                    </Col>
                    <Col sm={12} xs={24} md={12} lg={12}>
                      <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                        User's Email ID
                        <span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                      </label>

                      <input
                        name="emailId"
                        className="EditUserTextInput"
                        value={formData.emailId}
                        placeholder="Enter User's Email ID"
                        feedbackMessage={errors.emailId}
                        error={!!errors.emailId}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Don't allow space as the first character
                          if (value.startsWith(" ")) {
                            return;
                          }

                          handleInputChange(e);
                        }}
                      />
                      {touched.emailId && errors.emailId && (
                        <div className="createClientErrors">{errors.emailId}</div>
                      )}
                    </Col>
                    <Col sm={12} xs={24} md={12} lg={12}>
                      <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                        Password
                        <span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                      </label>

                      <div className="password-field-container-edituser">
                        <input
                          name="password"
                          className="EditUserTextInput"
                          value={formData.password}
                          placeholder="Enter Password"
                          type={passwordVisible ? "text" : "password"}
                          autoComplete="off"
                          feedbackMessage="Please input the password."
                          onChange={(e) => {
                            const value = e.target.value.trimStart();

                            handlePasswordChange({
                              ...e,
                              target: {
                                ...e.target,
                                name: "password",
                                value: value,
                              },
                            });
                          }}
                        />

                        {formData.password && (
                          <span
                            className="eye-icon"
                            onClick={() => setPasswordVisible(!passwordVisible)}
                          >
                            {passwordVisible ? <FaEye /> : <FaEyeSlash />}
                          </span>
                        )}
                      </div>

                      {touched.password && errors.password && (
                        <div className="createClientErrors">
                          {errors.password}
                        </div>
                      )}
                    </Col>
                    <Col sm={12} xs={24} md={12} lg={12}>
                      <label style={{ fontSize: "15px", color: "#1C1B1F" }}>
                        Contact Number<span style={{ color: "#AD0101", marginLeft: "4px" }}>*</span>
                      </label>

                      <input
                        type="tel"
                        name="phoneNumber"
                        className="EditUserTextInput"
                        value={formData.phoneNumber || ""}
                        placeholder="Enter User's Contact No."
                        maxLength={10}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");

                          // Maximum 10 digits
                          value = value.slice(0, 10);

                          // First digit should be only 5, 6, 7, 8, or 9
                          if (value.length > 0 && !/^[5-9]/.test(value)) {
                            return;
                          }

                          handleInputChange({
                            target: {
                              name: "phoneNumber",
                              value: value,
                            },
                          });
                        }}
                      />

                      {touched.phoneNumber && errors.phoneNumber && (
                        <div className="createClientErrors">
                          {errors.phoneNumber}
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Footer Buttons */}
          <div className="modal-footer">
            {selectedUser && (
              <button
                style={{
                  color: selectedUser.userStatus === 1 ? "#AD0101" : "green", // Red for deactivate, green for activate
                  border: `1px solid ${selectedUser.userStatus === 1 ? "#AD0101" : "green"}`, // Matching border color
                  padding: "5px 10px", // Add padding for better visibility
                  borderRadius: "5px", // Optional rounded corners
                }}
                className="global-admin-delete-icon-button"
                onClick={() => showDeleteModal(selectedUser)} // Only the selected user
              >
                <span style={{ color: selectedUser.userStatus === 1 ? "#AD0101" : "green", }}>
                  {selectedUser.userStatus === 1 ? "Deactivate User" : "Activate User"}
                </span>
              </button>
            )}

            <div className="edit-cancel-and-apply"
              style={{
                display: "flex", gap: "12px", width: "102%", justifyContent: "end"
              }}
            >
              <button className="global-admin-discard-button" onClick={handleCancel}>
                Cancel
              </button>
              <button className="global-admin-apply-button" onClick={handleSubmit} >
                Apply
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {isMobile && (
        <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
          <div className="mobile-menu-header">
            <span style={{ fontSize: "large", fontFamily: "Inter" }}>Close</span>
            <X className="menu-close-icon" onClick={toggleMobileMenu} />
          </div>
          {userData && (
            <div className="mobile-profile-info">
              <img
                src={userData.profilePicture ? userData.profilePicture : defaultProfile}

                alt="User"
                className="is-mobile-profile-image"
              />
              <div className="is-mobile-text-container">
                <span className="is-mobile-profile-name">{truncateUserName(userData.name)}</span>
                <span className="is-mobile-profile-designation">{truncateDesignation(userData.designation)}</span>
              </div>
            </div>
          )}

          <button className="mobile-menu-item active" onClick={() => {
            navigate('/dashboard');
            toggleMobileMenu();
          }}>
            <span>Dashboard</span>
            <img
              src={Home}
              alt="Home"
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "7%",
              }}
            />
          </button>

          <button className="mobile-menu-item" onClick={() => {
            navigate('/global-admin');
            toggleMobileMenu();
          }}>
            <span>Global Admin</span>
            <img
              src={GlobalIcon}
              alt="Create"
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "7%",

              }}
            />
          </button>
          <button className="mobile-menu-item" onClick={() => {
            navigate('/reports');
            toggleMobileMenu();
          }}>
            <span>Reports</span>
            <img
              src={ReportsIcon}
              alt="Create"
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "7%",

              }}
            />
          </button>
          {/* <button className="mobile-menu-item" onClick={() => {
            navigate('/ticketing-system');
            toggleMobileMenu();
          }}>
            <span>CS Login & Ticketing</span>
            <img
              src={TicketingSystemIcon}
              alt="Create"
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "7%",

              }}
            />
          </button> */}
          <button className="mobile-logout-button" onClick={logout}>
            <span>Logout</span>
            <IoIosLogOut className="logout-icon" />
          </button>
        </div>
      )}


    </header>
  );
};

export default ReusableHeader;
